import React, { Component } from 'react';
import { connect } from 'react-redux';

import ERRORSWARNINGS_CONTROLLER from '../../controllers/errorsWarnings';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import { ErrorWarningAction } from '../../utils/enums';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import NewTask from './bulkReplace/NewTask';
import NodeSelector from './bulkReplace/NodeSelector';
import TaskList from './bulkReplace/TaskList';

import Logger, { LOG_LEVELS } from '../../utils/logger';

const log = new Logger('BULK_FIND_AND_REPLACE_PANEL', LOG_LEVELS.DEBUG);

export class BulkReplacePanel extends Component {

  constructor(props){
      super(props);
      this.state = Object.assign({}, this.state, {tasks: [], selectedNodeIndex: 0});
  }

  onNodeSelect(payload) {
    log.debug("onNodeSelect(): payload: ", payload);
    this.setState({
        selectedNodeIndex: payload && payload.index
    });
  }

  onTaskRemove(payload) {
    log.debug("onTaskRemove(): payload: ", payload);
     let selectedIndex = (payload && payload.selectedIndex) || [];
     let curTasks = this.state.tasks.slice(0);
     selectedIndex.forEach(element => {
      curTasks.splice(selectedIndex, 1);
     });
     this.setState({tasks: curTasks});
  }

  onTaskAdd(payload) {
    log.debug("onTaskAdd(): payload: ", payload);
    //let newTask = (payload && (payload.newValue || payload.currentValue)) || -1;
    //if(newTask === -1) return;
    let curTasks = this.state.tasks.slice(0);
    curTasks.push({
        node: this.props.nodeList[this.state.selectedNodeIndex],
        currentValue: payload.currentValue || '',
        newValue: payload.newValue || '',
        currentCheckboxValue: payload.currentCheckboxValue,
        newCheckboxValue: payload.newCheckboxValue,
        replaceAllNodeValues: !!payload.replaceAllNodeValues
    });
    this.setState({tasks: curTasks});
    log.debug("onTaskAdd(): tasks: ", curTasks);
  }

  onClickApply(event) {
    log.debug("onClickApply(): event: ", event);
    const errorList = this.props.errorList || [];
    const errorIds = errorList.map((error, index) => {
      return error.id;
    });
    log.debug("onClickApply(): errorIds: ", errorIds);    
    const replaceTagValues = this.state.tasks.map((task, index) => {
      const replaceAll = !!task.replaceAllNodeValues;
      return {
        "nodeName": task.node,
        "flagCurrentValue": replaceAll ? 2 : (task.currentCheckboxValue ? 1 : 0),
        "currentValue": replaceAll ? '' : task.currentValue,
        "flagNewValue": task.newCheckboxValue ? 1 : 0,
        "newValue": task.newValue
      };
    });    
    log.debug("onClickApply(): replaceTagValues: ", replaceTagValues);    
    log.debug('onClickApply() errorIds: ', errorIds);
    if(typeof this.props.onApply === 'function') {
      this.props.onApply(errorIds, replaceTagValues);
    }
  }

  onClickCancel() {
     this.setState({
       tasks: []
     });
     if(typeof this.props.onCancel === 'function')  {
      this.props.onCancel();
     }
  }	

  render() {
    log.debug('render: ', this.props);
    const nodes = this.props.nodeList || [];
    const enableApplyButton =  Array.isArray(this.state.tasks) && this.state.tasks.length > 0;
    return (
      <fieldset>
        <h2>{LANGUAGES_CONTROLLER.format(this.props.languages, 'bulkFindReplace_title')}</h2>
          <div className="bulk-find-and-replace">
            <NodeSelector list={nodes} selected={0} onChange={(e) => this.onNodeSelect(e)} />
            <NewTask onAdd={(e) => this.onTaskAdd(e)} />
            <TaskList list={this.state.tasks} onRemove={(d) => this.onTaskRemove(d)}/>                
            <button 
              className={ enableApplyButton ? "primary mt10" : "primary mt10 disabled"} 
              onClick={() => this.onClickApply()} 
              disabled={enableApplyButton ? '' : 'disabled'}
              value="Apply"  
            >
              <LanguageStringResolver string='apply'/>
            </button>
            <button className="secondary mt10" onClick={() => this.onClickCancel()} >
              <LanguageStringResolver string='cancel'/>
            </button>
          </div>
      </fieldset>
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages
  };
}

function mapDispatchersToProps(dispatch) {
  const dispatchProps = {
    doApplyErrorsAndReload: (errorIds, replaceTagValues, cb) => {
      dispatch(ERRORSWARNINGS_CONTROLLER.doActionOnIds(ErrorWarningAction.ERROR_ACTION_MOVE.value, errorIds, replaceTagValues, cb));
    }
  }
  return dispatchProps;
}


BulkReplacePanel.defaultProps = {
  onCancel: () => {},
  onApply: ()=> {}
}

// Wrap the component to inject state into it
export default connect(mapStateToProps, mapDispatchersToProps)(BulkReplacePanel);
